const MAX_KEYS = [
	'max_domains',
	'maxDomains',
	'max_allowed_domains',
	'maxAllowedDomains',
	'max_allowed',
	'maxAllowed',
	'limit',
	'max',
] as const;

function pickMaxFromRecord(obj: Record<string, unknown>): number | null {
	for (const key of MAX_KEYS) {
		const v = obj[key];
		if (typeof v === 'number' && Number.isFinite(v) && v > 0) {
			return Math.floor(v);
		}
		if (typeof v === 'string' && /^\d+$/.test(v)) {
			const n = parseInt(v, 10);
			return Number.isFinite(n) && n > 0 ? n : null;
		}
	}
	return null;
}

/**
 * Разбор тела ответа `GET api/wgt/domains`.
 * Поддерживаются варианты: `{ data: string[] }`, `{ data: { domains, max_* } }`,
 * массив в корне и числовые лимиты на корне или внутри `data`.
 */
export function parseWidgetDomainsResponse(responseData: unknown): {
	domains: string[];
	maxAllowed: number | null;
} {
	if (!responseData || typeof responseData !== 'object') {
		return { domains: [], maxAllowed: null };
	}

	const root = responseData as Record<string, unknown>;
	const maxFromRoot = pickMaxFromRecord(root);
	const inner = root.data;

	if (Array.isArray(inner)) {
		const domains = inner.filter((x): x is string => typeof x === 'string');
		return { domains, maxAllowed: maxFromRoot };
	}

	if (inner && typeof inner === 'object' && !Array.isArray(inner)) {
		const o = inner as Record<string, unknown>;
		const rawList = o.domains ?? o.list ?? o.items ?? o.data;
		const domains = Array.isArray(rawList)
			? rawList.filter((x): x is string => typeof x === 'string')
			: [];
		const maxInner = pickMaxFromRecord(o);
		return {
			domains,
			maxAllowed: maxInner ?? maxFromRoot,
		};
	}

	return { domains: [], maxAllowed: maxFromRoot };
}
